"use client";
import { motion } from "motion/react";

import { Icon } from "@ospweb/sdk-ui";
import React from "react";
import RelatedItem from "./RelatedItem";
import Translations from "@translate/components/Chat/Related/RelatedList";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

interface RelatedPropsType {
  data: string[];
  isLast?: boolean;
  streamLoading?: boolean;
  onSendRelatedValue?: (inputString: string) => void;
  itemClassName?: string;
}
function Related({
  data,
  isLast,
  onSendRelatedValue,
  itemClassName,
}: RelatedPropsType) {
  const toSend = (i: string) => {
    onSendRelatedValue?.(i);
  };

  if (!data?.length || !isLast) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="overflow-auto flex-1"
      role="region"
      aria-label="More Questions"
    >
      <div>
        <div className="flex items-center gap-2">
          <Icon
            name="ai-magic-wand"
            color="white"
            aria-hidden="true"
            size={16}
          />
          <div className="body_medium_m py-4" role="heading" aria-level={2}>
            {I18n.t("More Questions")}
          </div>
        </div>
        <div className="flex gap-2 overflow-auto flex-col flex-1">
          {data.map((question, index) => (
            <RelatedItem
              key={index}
              question={question}
              onSendRelatedValue={toSend}
              className={itemClassName}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
}

export default React.memo(Related);
